import React from "react";
import {
  Box,
  Button,
  Typography
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import leftArrow from "../../../assests/leftArrow.svg";
import Sidebar from "../../Navigation/Sidebar/Sidebar";

const hours = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));

const CouponTimePicker = ({
  timePairs,
  setTimePairs,
  setFinalData,
  updatePair,
  addPair,
  removePair,
  couponCreationStep6,
  active,
  setActive,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/");
  };

  const goback = () => {
    navigate(-1);
  };

  return (
    <div className="main-div">
      <div>
        <Sidebar />
      </div>

      <div>
        <div style={{ marginLeft: "42px", marginTop: "20px" }}>
          <h2>
            <img
              onClick={handleClick}
              style={{ width: "22px", cursor: "pointer" }}
              src={leftArrow}
              alt=""
            />{" "}
            Create Coupon
          </h2>
        </div>
        <Box sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Is it only applicable for particular time slot
          </Typography>
          <div className={`half-border-box ${active}`} data-active={active}>
            <button
              className={`yes-button ${active === "yes" ? "active" : ""}`}
              onClick={() => setActive("yes")}
              data-tooltip="Select Yes"
            >
              Yes
            </button>
            <button
              className={`no-button ${active === "no" ? "active" : ""}`}
              onClick={() => setActive("no")}
              data-tooltip="Select No"
            >
              No
            </button>
          </div>
          <Button className="backbtn" onClick={goback}>
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={(e) => couponCreationStep6(e)}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              width: 120,
              height: 40,
              background: "rgba(0, 177, 119, 1)",
            }}
          >
            NEXT
          </Button>
        </Box>
      </div>
    </div>
  );
};

export default CouponTimePicker;
